import React from "react";
import { Container, Row, Table, Button, Col } from "react-bootstrap";
import { DraggableTable } from "presentation/components/draggable-table/table";
import { TableStyles } from "presentation/components/draggable-table/table-styles";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import AddButton from "presentation/components/buttons/add";

import ManagePeriodModal from "presentation/pages/evaluation-schemes/elements/manage-period-modal";

import DropdownMenu from "presentation/components/dropdown-menu/menu";
import EditItemTitle from "presentation/components/dropdown-menu/item-title/edit";
import RemoveItemTitle from "presentation/components/dropdown-menu/item-title/remove";
import { DROPDOWN_MENU_TYPE_ITEM } from 'presentation/model/constants';

import {
    arrayMove
} from "@dnd-kit/sortable";
import { isNullOrEmpty } from "presentation/utils/functions/generic";

class PeriodsTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            actionLoading: false,
            error: false,
            message: '',
            data: [],
            showConfirmModal: false,
            showManagePeriodModal: false,
            targetDeleteId: null,
            draggableTableData: [],
            periodKey: null,
            period: {},
            periodId: null
        };
        this.closeModal = this.closeModal.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.makeData = this.makeData.bind(this);
    }

    componentDidMount() {
        this.makeData();
    }

    openModal = (id) => {
        this.setState({ targetDeleteId: id, showConfirmModal: true });
    }

    closeModal = () => {
        this.setState({ showConfirmModal: false, targetDeleteId: null });
    }

    openManagePeriodModal = (period = {}, periodId = null, periodKey = null) => {
        this.setState({ showManagePeriodModal: true, period: period, periodId: periodId, periodKey: periodKey });
    }

    closeManagePeriodModal = () => {
        this.setState({ showManagePeriodModal: false, period: {}, periodId: null, periodKey: null });
    }

    deleteItem = () => {
        let me = this;
        let { component } = me.props;
        let { periods } = component.state;
        let { targetDeleteId } = me.state;
        let { makeData } = me;

        if (targetDeleteId) {
            let target = periods.filter(x => x.id == targetDeleteId)[0];

            target.isDeleteRequested = true;

            let others = periods.filter(x => x.id != targetDeleteId);
            let newValues = [];

            if (target.id && !target.isVirtualId) {
                newValues = [...others, target];
            } else {
                newValues = [...others];
            }


            component.setState(
                { periods: newValues }, () => {
                    makeData();
                    me.setState({ targetDeleteId: null, showConfirmModal: false });
                });
        }
    }

    makeData = () => {
        let { openModal, openManagePeriodModal } = this;
        let { component } = this.props;
        let { periods, stages } = component.state;

        var validOptions = periods.filter(x => !(x.isDeleteRequested == true)).sort((a, b) => a.weight - b.weight);


        var data = validOptions.map((e, i) => {
            let periodStage = stages.filter(x => x.id == e.stageId)[0];
            var id = e.id;

            e.rowOrder = "";

            e.rowStageName = (<div className="table-cell-height-limited">{periodStage?.name}</div>);
            e.rowPeriodName = (<div className="table-cell-height-limited">{e.name}</div>);
            e.rowPeriodShortName = (<div className="table-cell-height-limited">{e.displayName}</div>);
            e.rowPeriodOverwrites = (<div className="table-cell-height-limited">{""}</div>);
            e.rowActions = (
                <DropdownMenu
                    items={[
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <EditItemTitle />, props: { onClick: () => openManagePeriodModal(e, id, e.key) } },
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <RemoveItemTitle />, props: { onClick: () => openModal(id) } }
                    ]}
                />);

            return e;
        });
        this.setState({ draggableTableData: data });
    };

    setData = (event) => {
        const { active, over } = event;
        let { component } = this.props;
        const { periods } = component.state;

        const { draggableTableData } = this.state;

        const items = draggableTableData?.map(({ id }) => id);

        if (active.id !== over.id) {

            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            let reorderedData = arrayMove(draggableTableData, oldIndex, newIndex);

            let ordersDisctionary = [];

            reorderedData.map((e, i) => {
                e.weight = i;
                ordersDisctionary.push({ periodId: e.id, weight: i });
                return e;
            });

            periods.map((q, i) => {
                let weight = ordersDisctionary.filter(x => x.periodId == q.id)[0]?.weight;
                q.weight = weight;
                return q;
            });

            component.setState({ periods: periods }, () => { this.setState({ draggableTableData: reorderedData }) });


        }
    };


    render() {
        const { loading, actionLoading, error, message, showConfirmModal, showManagePeriodModal, draggableTableData, period, periodKey, periodId } = this.state;

        const { deleteItem, closeModal, openManagePeriodModal, closeManagePeriodModal, setData, makeData } = this;

        let { component, stages, periods, evaluationTypes } = this.props;

        let { totalPeriodItems } = this.props;

        const validStages = stages.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        const validPeriods = periods.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        let nextPeriodKey = totalPeriodItems + 1;
        let mode = period.id ? "edit" : "add";

        const headers = [
            { Header: "#", accessor: "rowOrder", style: { width: "10%", textAlign: "center" } },
            { Header: "Etapa", accessor: "rowStageName", style: { width: "25%" } },
            { Header: "Período", accessor: "rowPeriodName", style: { width: "30%" } },
            { Header: "Nome Abreviado", accessor: "rowPeriodShortName", style: { width: "15%" } },
            { Header: "Substitui nota do(s) período(s)", accessor: "rowPeriodOverwrites", style: { width: "15%" } },
            { Header: "Ações", accessor: "rowActions", style: { width: "5%" } }
        ];


        return (
            <div>
                {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
                {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {loading === false && error === false && draggableTableData.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
                {loading === false && (
                    <Container>
                        <Row>
                            <Col size={4} className="mt-4">
                                <AddButton
                                    containerProps={{
                                        onClick: () => openManagePeriodModal(),
                                        disabled: validStages.length < 1
                                    }}

                                />
                            </Col>
                            <Container>
                                <h6 className="float-end mt-4 mb-4">Total de períodos: {draggableTableData.length || 0}</h6>
                                <TableStyles>
                                    <DraggableTable columns={headers} data={draggableTableData} setData={setData} />
                                </TableStyles>
                            </Container>
                        </Row>
                        <ManagePeriodModal
                            show={showManagePeriodModal}
                            afterSubmit={makeData}
                            onClose={closeManagePeriodModal}
                            component={component}
                            stages={validStages}
                            periods={validPeriods}
                            evaluationTypes={evaluationTypes}
                            periodKey={periodKey != null ? periodKey : nextPeriodKey}
                            periodId={periodId}
                            period={period}
                            mode={mode}
                        />
                        <PageModal
                            show={showConfirmModal}
                            onClose={closeModal}
                            onConfirm={deleteItem} />
                    </Container>
                )}
            </div>
        );
    };
}

export default PeriodsTabEvaluationSchemeForm;


